import { of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';

import { PRODUCT_IMPORT_JOB_COMPLETE, PRODUCT_IMPORT_V3_JOB_COMPLETE } from '../../services/pusher-service/pusher-contract-messages';
import { createPusherMessageCache } from './message-cache';

/*
New pusher message contract:
{
  data: {
    Success = Boolean,
    JobId = Guid,
    Errors = List<string>
  },
  sellerId: number
}
*/

export const startProductImportAndRespond = (curriedApi) => {
  const { findMessage } = createPusherMessageCache([PRODUCT_IMPORT_JOB_COMPLETE, PRODUCT_IMPORT_V3_JOB_COMPLETE]);

  return curriedApi().pipe(
    switchMap((response) => {
      const [jobGuid] = response.jobGuids;
      const messageChecker = (pusherMessage) => {
        return (pusherMessage.jobId ?? pusherMessage?.data?.JobId) === jobGuid;
      };
      return of({
        findMessage$: findMessage(messageChecker).pipe(
          take(1),
          map((pusherMessage) => {
            // precedence is for new V3queueservice pusher message style style ({ data: {...} })
            // with fallback to legacy pusher message  (raw message object from the wild west)
            const pusherResponse = pusherMessage?.data ?? pusherMessage;
            return { response: pusherResponse };
          }),
        ),
      });
    }),
  );
};
